import { render, staticRenderFns } from "./buyKesehatan.vue?vue&type=template&id=ac71ea90&"
import script from "./buyKesehatan.vue?vue&type=script&lang=ts&"
export * from "./buyKesehatan.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports